import { useState, useEffect } from "react";
import { FetchedReportData } from "../../types";
import useFetchWithAuth from "./useFetchWithAuth";
import { getApiUrl } from "../../utils/api";

const useReportDetails = (id: string | undefined) => {
  const { fetchWithAuth } = useFetchWithAuth();
  const [reportDetails, setReportDetails] = useState<
    FetchedReportData | undefined
  >(undefined);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchReportDetails = async () => {
      if (!id || reportDetails?._id) return;

      setLoading(true);
      setError(null);

      try {
        const response = await fetchWithAuth(getApiUrl(`/admin/report/${id}`));
        setReportDetails(response);
      } catch (err: any) {
        setError(err.message || "An unknown error occurred.");
      } finally {
        setLoading(false);
      }
    };

    fetchReportDetails();

    // eslint-disable-next-line
  }, [id]);

  return { reportDetails, loading, error, setReportDetails };
};

export default useReportDetails;
